import { render, staticRenderFns } from "./SkemaKomisi.vue?vue&type=template&id=66ae6794&scoped=true&"
import script from "./SkemaKomisi.vue?vue&type=script&lang=js&"
export * from "./SkemaKomisi.vue?vue&type=script&lang=js&"
import style0 from "./SkemaKomisi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SkemaKomisi.vue?vue&type=style&index=1&id=66ae6794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae6794",
  null
  
)

export default component.exports